import Alert from 'flarum/common/components/Alert';

export default function showAlert(alertText,alertType){
  if(alertType===undefined){
    alertType = "error";
  }

  const alert = app.alerts.show(Alert, {type: alertType}, alertText);
  setTimeout(function(){
    app.alerts.dismiss(alert);
  },5000)
}
